import React from 'react';

import * as IconTb from 'react-icons/tb';

import './ComingSoon.scss';

const ComingSoon = () => {

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div className="d-flex flex-column align-items-center text-center coming-soon">
            <IconTb.TbHourglassEmpty size={48} className="sw-1 mb-3"/>
            <span className="text-primary h3 fw-bold">بـزودی</span>
            <span className="text-primary fs-5">این بخش در دست راه اندازی می باشد</span>
        </div>
    )
}

export default ComingSoon;